import React, { useState, useEffect } from "react";
import "../css/components.css"



type SelectSectionProps={
  item:Object; text:String, isActive:Boolean, setIsActive:Function
}


function SelectSection({item, text,isActive, setIsActive }:SelectSectionProps) {

  return ( 
    <div className="select_section_container">
      <button
        onClick={(e) => {
          setIsActive(item);
        }}
        className={
          isActive ? "select_sec_active" : "select_sec_inactive"
        }
      >
        {text}
      </button>
    </div>
  );
}

export default SelectSection;
